import {
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
  MAX_PAGE_SIZE,
  Pagination,
} from './paged.list';

export class PaginationHelper {
  static sanitize({
    pageSize,
    pageIndex,
  }: Partial<Pagination> = {}): Pagination {
    const safePageIndex =
      pageIndex !== undefined && Number.isInteger(pageIndex) && pageIndex >= 0
        ? pageIndex
        : DEFAULT_PAGE_INDEX;

    const safePageSize =
      pageSize !== undefined && Number.isInteger(pageSize) && pageSize > 0
        ? Math.min(pageSize, MAX_PAGE_SIZE)
        : DEFAULT_PAGE_SIZE;

    const rv: Pagination = { pageSize: safePageSize, pageIndex: safePageIndex };
    return rv;
  }

  static getOffset(pageIndex?: number, pageSize?: number): number {
    const { pageIndex: safePageIndex, pageSize: safePageSize } = this.sanitize({
      pageSize,
      pageIndex,
    });
    const rv = safePageIndex * safePageSize;
    return rv;
  }

  static getLimit(pageSize?: number): number {
    const { pageSize: safePageSize } = this.sanitize({
      pageSize,
      pageIndex: 0,
    });
    return safePageSize;
  }
}
